import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismBadge } from '@mylighthouse/prism-ember';
import type { CostSettingProfile } from 'lumen/models';

export interface SettingsCostTablesCellsTdTypesSignature {
  Args: {
    cellData: CostSettingProfile;
  };
  Element: HTMLTableCellElement;
}

export default class SettingsCostTablesCellsTdTypes extends Component<SettingsCostTablesCellsTdTypesSignature> {
  @service declare intl: Services['intl'];

  get pills(): string[] {
    // Composed as "<type>: <value>%". The unit/basis formatting is formalised
    // with dedicated keys in PIN-1245; for now only simple commission % exists.
    return this.args.cellData.costs.reduce<string[]>((labels, cost) => {
      const { value } = cost.costValues;
      if (value !== null) {
        const label = this.intl.t('settings.cost.commission');
        labels.push(`${label}: ${value}%`);
      }
      return labels;
    }, []);
  }

  <template>
    <div class="flex flex-wrap gap-100">
      {{#each this.pills as |pill|}}
        <PrismBadge @label={{pill}} @type="neutral" />
      {{/each}}
    </div>
  </template>
}
